















































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import TsUpload from "@/components/upload.vue";

import MyForm from "@/mixins/form";

@Component({
  components: {
    TsUpload,
  },
})
export default class extends Mixins(MyForm) {

  @Prop() stadiumId!: any;
  handleChange() {}
  list = [];

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确认要保存吗？",
          onOk: async () => {
            const res = await this.$store.dispatch("specialOperation/edit", {
              stadium_id: this.stadiumId,
              data: JSON.stringify(values)
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success("保存成功");
              this.handleCancel();
            } else {
              this.$message.error("保存失败");
            }
          },
        });
      }
    });
  }

  async getList() {

  }

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("specialOperation/list", {
      stadium_id: this.stadiumId,
    });
    if (res && res.Data) {
      this.formData = res.Data;
      this.list = res.Data;
    }

    console.log("__data__", res.Data);

    this.spinLoading = false;
  }
}
